const borderWidth = {
    none: '0px',
    base: '1px',
    emphasis: '2px'
} as const;

export default borderWidth;
